<template>
  <div class="tabs is-boxed is-centered">
    <ul>
      <router-link :to="tab.to" exact-active-class="is-active" tag="li" class="is-size-5-tablet is-size-6-mobile" v-for="tab in tabs" :key="tab.to">
        <a>{{ tab.title }} <span class="my-tag ml-1" v-if="tab.count">{{ tab.count }}</span></a>
      </router-link>
    </ul>
  </div>
</template>

<script>
import { LinkTabs as validator } from '../validators'

export default {
  name: 'LinkTabs',
  props: {
    tabs: {
      validator,
    }
  },
  components: {},
  computed: {},
}
</script>



// WEBPACK FOOTER //
// LinkTabs.vue?3780c87b